import { apiGet, apiPost } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import * as documentPortalActions from './documentPortalActions';
import * as notifications from './notificationActions';
import { browserHistory } from 'react-router';

function allowMonthlyAndYearly() {
  return {
    type: 'RENEWAL_LEASE_WIZARD::ALLOW_MONTHLY_AND_YEARLY',
  };
}

function allowYearly() {
  return {
    type: 'RENEWAL_LEASE_WIZARD::ALLOW_YEARLY',
  };
}

function allowMonthly() {
  return {
    type: 'RENEWAL_LEASE_WIZARD::ALLOW_MONTHLY',
  };
}

export function updateDocumentToSign(documentToSign) {
  return {
    type: 'RENEWAL_LEASE_WIZARD::UPDATE_DOCUMENT_TO_SIGN',
    documentToSign,
  };
}

export function renewalOptions(document_id) {
  return dispatch => {
    return apiGet(Auth.getApiUrl() + `/document_signing/renewal_options/${document_id}`)
      .done(response => {
        setTimeout(() => {
          dispatch(notifications.hideLoader());
        }, 10);
        if (response.allow_monthly && response.allow_yearly) {
          dispatch(allowMonthlyAndYearly());
        } else if (!response.allow_monthly && response.allow_yearly) {
          dispatch(allowYearly(response.documentToSign));
        } else if (response.allow_monthly && !response.allow_yearly) {
          dispatch(allowMonthly(response.documentToSign));
        }

        dispatch(updateDocumentToSign(response.nextDocumentToSign));
      })
      .catch(error => {
        dispatch(documentPortalActions.signError());
      });
  };
}

export function tenantMonthToMonth(document_id, redirect_url = '/dashboard') {
  return dispatch => {
    return apiPost(Auth.getApiUrl() + `/document_signing/go_month_to_month/${document_id}`)
      .done(response => {
        browserHistory.push(redirect_url);
        dispatch(notifications.showSuccess('leaseSuccessfullyRenewed'));
      })
      .catch(error => {
        dispatch(documentPortalActions.signError());
      });
  };
}
